import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomeNewsActivity from './Pages/NewsActivity/HomeNewsActivity';
import Registration from './Pages/Admin/Registration';
import Login from './Pages/Admin/Login';
import Home from './Pages/Admin/Home';
import OrderShirt from './Pages/Admin/OrderShirt';
import TermsOfUse from './Pages/Home/TermsOfUse';
import PrivacyPolicy from './Pages/Home/PrivacyPolicy';
import HemodialysisUnitNew from './Pages/CenterHemodialysis/HemodialysisUnitNew';
import AboutUs from './Pages/Home/AboutUs';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <Routes>
      <Route path="/*" exact element={<App />} />
      <Route path="/hemodialysisUnit/*" exact element={<HemodialysisUnitNew />} />
      <Route path="/newsActivity/*" exact element={<HomeNewsActivity />} />
      <Route path="/login/*" exact element={<Login />} />
      <Route path="/home/*" exact element={<Home />} />
      <Route path="/about/*" exact element={<AboutUs />} />
      <Route path="/termsOfUse/*" exact element={<TermsOfUse />} />
      <Route path="/privacyPolicy/*" exact element={<PrivacyPolicy />} />
      <Route path="/registration/*" exact element={<Registration />} />
      <Route path="/Order-a-Shirt/*" exact element={<OrderShirt />} />
    </Routes>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
